import React from "react";
import { Button, type ButtonProps } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface IconActionProps extends Omit<ButtonProps, "children" | "size"> {
  /** Used for both the tooltip and the accessible name. */
  label: string;
  icon: React.ReactNode;
  tone?: "default" | "destructive";
  size?: "icon" | "icon-sm";
}

/** Icon-only button with a tooltip and an accessible label (row actions, toolbars). */
export const IconAction = React.forwardRef<HTMLButtonElement, IconActionProps>(
  ({ label, icon, tone = "default", size = "icon-sm", className, variant = "ghost", ...props }, ref) => (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          ref={ref}
          variant={variant}
          size={size}
          aria-label={label}
          className={cn(
            "text-muted-foreground hover:text-foreground",
            tone === "destructive" && "hover:bg-destructive/10 hover:text-destructive",
            className,
          )}
          {...props}
        >
          {icon}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  ),
);
IconAction.displayName = "IconAction";
